/// <reference path="~/js/viz/shared/views/NoDataView.js"/>

(function() {
  var ns;

  ns = window.nspace("ccc.viz.bar.views");

  /**
   * A friendly no data message view that appears if a user unselects all checkboxes.
   */
  ns.NoBarDataView = window.ccc.viz.shared.views.NoDataView.extend({
    el: "#bar-chart-container",
    name: "No bar data view",
    templateSelector: "#no-bar-data-template",

    render: function() {
      var self;

      self = this;
      if (self.selectorsModel.areModelArraysValid() && self.model.hasData()) {
        return;
      }

      // Verify this selector's container is present
      if (self.$el.length === 0) {
        throw "Could not find the " + self.name + " container: " + self.el;
      }

      // Load the template
      self.loadTemplate();

      // Render the output
      self.$el.html(self.template());

      // Animate the transition
      self.$el.hide().fadeIn(function() {
        self.initialRenderPromise.resolve();
      });
    }
  });
})();
